import { gitlabInstructions } from "./gitlabInstructions";
import { githubInstructions } from "./githubInstructions";
import { circleCiInstructions } from "./circleCiInstructions";
import { azureInstructions } from "./azureInstructions";
import { jenkinsInstructions } from "./jenkinsInstructions";

interface Flag {
  id: string;
  title: string;
}

export type CiCdConfigExample = {
  id: string;
  config: string;
};

type CiCdInstructions = {
  title: string;
  tagline: string;
  flags: Flag[];
  instructions: {
    id: number;
    link?: string;
    href?: string;
    typography?: string;
    markdownText?: string;
    markdown?: string;
    tagline: string;
    token?: boolean;
    configExamples?: CiCdConfigExample[];
  }[];
};

export function getCicdInstructions(type: string): CiCdInstructions {
  switch (type.toLowerCase()) {
    case "azure":
      return azureInstructions;
    case "circleci":
      return circleCiInstructions;
    case "github":
      return githubInstructions;
    case "gitlab":
      return gitlabInstructions;
    case "jenkins":
      return jenkinsInstructions;
    default:
      return gitlabInstructions;
  }
}
